import type { FC } from 'react';

import { FacebookIcon, InstagramIcon, LinkedInIcon, XIcon, YouTubeIcon } from '@eneco/sparky/icons';

const SocialMediaIcon: FC<{ iconName: string }> = ({ iconName }) => {
  const arrSocialBrands = ['facebook', 'instagram', 'linkedin', 'twitter', 'youtube'];
  const strippedIconName = arrSocialBrands.find(socialBrand => iconName.toLowerCase().includes(socialBrand));

  switch (strippedIconName) {
    case 'youtube':
      return <YouTubeIcon />;

    case 'linkedin':
      return <LinkedInIcon />;

    case 'twitter':
      return <XIcon />;

    case 'instagram':
      return <InstagramIcon />;

    case 'facebook':
    default:
      return <FacebookIcon />;
  }
};

export default SocialMediaIcon;
